import React, { memo } from 'react';
import { useTranslation } from 'i18n';
import { makeEntitiesLoader } from 'hooks/makeSimpleLoader';

import { EventCategoriesActions } from 'store/actions';
import { EventCategoriesSelectors } from 'store/selectors';

import NestedMultipleFilterSelect from 'components/common/NestedSelect/NestedMultipleFilterSelect';
import { titleLabelFormatter } from './utils';

export interface IEventTopicsFilterProps {
  disabled?: boolean;
}

const useEventTopicsState = makeEntitiesLoader(
  EventCategoriesActions.getEventCategories,
  EventCategoriesSelectors.eventTopicsState,
);

const EventTopicsFilter: React.FC<React.PropsWithChildren<IEventTopicsFilterProps>> = (props) => {
  const { disabled } = props;

  const [t] = useTranslation();
  const state = useEventTopicsState();

  return (
    <NestedMultipleFilterSelect
      labelFormatter={titleLabelFormatter}
      items={state.entities}
      name="category"
      placeholderFormatter={(item: any) => item?.label || t('common:filter.category')}
      disabled={disabled || state.isFetching}
    />
  );
};

export default memo(EventTopicsFilter);
